<template>
    <div class="example">
        <mc-button
            type="text"
            size="small"
            @click="visible = true"
        >
            查看示例
        </mc-button>
        <mc-modal
            v-model="visible"
            title="查看示例"
            width="350px"
        >
            非 PC 场景请根据对应运输箱规长宽高进行自定义设置，PC 场景箱规长宽高请按照以下参数示例设置：
            <div
                v-for="(item, idx) in example"
                :key="idx"
            >
                <div
                    class="text-info"
                >
                    {{ item.desc }}
                </div>
                <mc-image
                    v-if="item.pics.length"
                    :src="item.pics[0]"
                    :preview-url-list="item.pics"
                />
            </div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <mc-button
                    type="primary"
                    size="small"
                    @click="visible = false"
                >我知道了</mc-button>
            </span>
        </mc-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {
            visible: false,
            example: [
                {
                    desc: '示例一、PC 场景大筐长宽高按照 60*40*23.5 cm 设置',
                    pics: ['https://p0.meituan.net/mallimages/82bb6a32ad2ee66667d2e5642c60beb7827251.png'],
                },
                {
                    desc: '示例二、PC 场景小筐长宽高按照 60*40*16.5 cm 设置',
                    pics: ['https://p0.meituan.net/mallimages/3ff7c406c16704d667a9275a12c4fc9f1210613.png'],
                },
            ],
        };
    },
    computed: {
    },
};
</script>

<style lang='scss' scoped>
/deep/ .mtd-btn-text {
    color: #4187ff;
    font-weight: bold;
}
/deep/ .mc-image {
    margin-bottom: 10px;
    .mc-image-inner-center {
        transform: translate(-50%, 0px)!important;
    }
}

/deep/ .mtd-modal {
    border-radius: 0px!important;
    .mtd-modal-header {
        padding: 11px 24px!important;
        background-color: #f7f7f7;
        .mtd-modal-title {
            text-align: center;
            font-size: 14px;
            margin-right: 0px!important;
        }
    }
    .mtd-modal-content-wrapper {
        padding: 32px 20px!important;
        color: #585D66;
    }
    .mtd-modal-footer {
        text-align: center!important;
        background-color: #f0f0f0;
        padding: 20px 20px;
        padding-top: 10px!important;
        .mtd-btn-primary {
            background-color: #4187ff!important;
            border-color: #4187ff!important;
            border-radius: 4px;
        }
    }
}
</style>
